import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.span`
  display: flex;
  cursor: pointer;
  color: ${props => props.theme.colors.blue};
  display: flex;
  align-items: center;
  &:hover {
    color: ${props => props.theme.colors.black};
  }
  & > svg {
    margin-right: 5px;
  }
  & > label {
    cursor: pointer;
  }
`;
const ActionButton = props => {
  const Icon = props.icon;
  return (
    <Wrapper onClick={props.handleClick}>
      {Icon && <Icon />}
      <label>{props.text}</label>
    </Wrapper>
  )
}

export default ActionButton;